import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { stateAbbreviations } from '../services/listingHelpers';

interface Props {
  initialQuery?: string;
  initialState?: string;
}

const SearchBar: React.FC<Props> = ({ initialQuery = '', initialState = '' }) => {
  const [query, setQuery] = useState(initialQuery);
  const [state, setState] = useState(initialState);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (query) params.set('q', query);
    if (state) params.set('state', state);
    navigate(`/search?${params.toString()}`);
  };

  return (
    <form onSubmit={handleSubmit} style={{
      display: 'flex', gap: '8px', flexWrap: 'wrap', maxWidth: '800px', width: '100%'
    }}>
      <input
        type="text"
        placeholder="Search rehabs, sober living, detox..."
        value={query}
        onChange={e => setQuery(e.target.value)}
        style={{
          flex: '2 1 180px', padding: '14px 16px', fontSize: '16px',
          border: '2px solid #e0e0e0', borderRadius: '8px', outline: 'none',
        }}
      />
      <select
        value={state}
        onChange={e => setState(e.target.value)}
        style={{
          flex: '1 1 130px', padding: '14px 12px', fontSize: '16px',
          border: '2px solid #e0e0e0', borderRadius: '8px', outline: 'none',
          background: '#fff',
        }}
      >
        <option value="">All States</option>
        {Object.entries(stateAbbreviations).sort((a, b) => a[1].localeCompare(b[1])).map(([abbr, name]) => (
          <option key={abbr} value={abbr}>{name}</option>
        ))}
      </select>
      <button type="submit" style={{
        flex: '0 0 auto', padding: '14px 28px', fontSize: '16px', fontWeight: 700,
        background: '#1a237e', color: '#fff', border: 'none', borderRadius: '8px',
        cursor: 'pointer',
      }}>
        Search
      </button>
    </form>
  );
};

export default SearchBar;
